import { ProductInterface } from '@pylot-data/fwrdschema'
import {
    Maybe,
    ConfigurableProduct,
    SelectedConfigurableOption,
    ConfigurableWishlistItem
} from '@pylot-data/pylotschema'

export type GetUiForConfigProductArgs = {
    product?: Maybe<ConfigurableWishlistItem> | Maybe<ProductInterface>
    options?:
        | Maybe<SelectedConfigurableOption>
        | Maybe<Maybe<SelectedConfigurableOption>[]>
}

/**
 * Get uid for config products would be alterative | temp solution
 * Native magento wishlist query has configurable_option { configurable_product_option_value_uid }
 * which is throwing error (Native bug) and once its resolved
 * this function can be removed and access uid directly from { item { configurable_product_option_value_uid } }
 * @param product ConfigurableProduct
 * @param options SelectedConfigurableOption
 * @returns string[]
 */
export const getUidForConfigProducts = ({
    product,
    options
}: GetUiForConfigProductArgs): string[] => {
    if (!product || !options?.length) return [] //return if not a config product

    const selectedUid: Array<string> = []

    options?.forEach((configOptions: { values: { uid: string }[] }) => {
        // Extract the UID from the matching bundle option
        const valueUid = configOptions?.values?.[0]?.uid || ''
        selectedUid.push(valueUid)
    })

    return selectedUid
}
